import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6100223b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/dashboard.scss?vue&type=style&index=0&id=6100223b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100223b",
  null
  
)

export default component.exports